import { useContext } from 'react';
import { InventoryDependencyContext } from 'site-modules/shared/components/inventory/inventory-dependency/inventory-dependency-context';

export const useInventoryDependency = () => {
  const { filters } = useContext(InventoryDependencyContext);

  return { filters };
};
